import FullscreenVendorSelect from "@/components/VendorSelect/FullscreenVendorSelect";
import { useVendorContext } from "@/contexts/vendor-context";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect } from "react";

const Index = () => {
  const { vendors } = useVendorContext();
  const router = useRouter();

  const hasMultipleVendors = !!vendors && vendors.length > 1;
  const hasSingleVendor = !!vendors && vendors.length === 1;

  useEffect(() => {
    if (hasSingleVendor) {
      router.push(`/${vendors![0]}/analytics`);
    }
  }, [router, vendors, hasSingleVendor]);

  return (
    <>
      <Head>
        <title>Sesamy Portal - Select vendor</title>
      </Head>
      {hasMultipleVendors && <FullscreenVendorSelect />}
    </>
  );
};

export default Index;
